import React, { forwardRef } from 'react';

import { classnames } from '@lumapps/classnames';
import { Theme } from '@lumapps/lumx/react';

export interface PlayVideoLinkProps {
    to: string;
    /** Set this flag to open cross instance content in a new tab. */
    crossInstanceInNewTab?: boolean;
    theme?: Theme;
    // Forwarded props.
    [key: string]: any;
}

const CLASSNAME = 'play-video-link';

export const PlayVideoLink = forwardRef<HTMLAnchorElement, PlayVideoLinkProps>(
    ({ to, theme, children, className, crossInstanceInNewTab, ...forwardedProps }, ref) => {
        let { target } = forwardedProps;

        if (crossInstanceInNewTab) {
            target = '_blank';
        }

        return (
            <a
                {...forwardedProps}
                href={to}
                target={target}
                rel={target === '_blank' ? 'noreferrer noopener' : undefined}
                className={classnames(className, CLASSNAME, 'lumx-link', {
                    'lumx-link--color-light': theme === Theme.dark,
                })}
                ref={ref}
            >
                {children}
            </a>
        );
    },
);
